import { SVGProps } from "react";

export const Icon6 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={78}
    height={86}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M76 66.244V30.38h-6.824l-25.778 2.236V84L76 66.244Z"
      fill="#A69DA3"
      stroke="#667786"
      strokeWidth={3}
      strokeLinejoin="round"
    />
    <mask
      id="review-icon-6-a"
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={78}
      height={86}
      fill="#000"
    >
      <path fill="#fff" d="M0 0h78v86H0z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M75.377 30.215 33.695 2 23.233 6.674l-.392-.266V19.83l-10.028 4.48-.393-.266v13.42l-10.028 4.48L2 41.677v14.108L43.682 84V70.333l9.808-4.382.612.415v-.688l.434-.194-.434-.294V52.699l9.809-4.382.611.414v-.688l.435-.194-.435-.294v-12.49l10.855-4.85Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M75.377 30.215 33.695 2 23.233 6.674l-.392-.266V19.83l-10.028 4.48-.393-.266v13.42l-10.028 4.48L2 41.677v14.108L43.682 84V70.333l9.808-4.382.612.415v-.688l.434-.194-.434-.294V52.699l9.809-4.382.611.414v-.688l.435-.194-.435-.294v-12.49l10.855-4.85Z"
      fill="#DBD8DA"
    />
    <path
      d="M33.695 2 34.816.344a2 2 0 0 0-1.937-.17L33.696 2Zm41.682 28.215.816 1.826a2 2 0 0 0 .305-3.482l-1.121 1.656ZM23.233 6.675l-1.12 1.655a2 2 0 0 0 1.936.17l-.816-1.826Zm-.392-.267 1.12-1.656a2 2 0 0 0-3.12 1.656h2Zm0 13.42.816 1.826a2 2 0 0 0 1.184-1.826h-2Zm-10.028 4.48-1.122 1.657a2 2 0 0 0 1.937.17l-.815-1.826Zm-.393-.265 1.121-1.656a2 2 0 0 0-3.12 1.656h2Zm0 13.42.816 1.826a2 2 0 0 0 1.184-1.826h-2Zm-10.028 4.48-1.12 1.656a2 2 0 0 0 1.936.17l-.816-1.826ZM2 41.677l1.121-1.656a2 2 0 0 0-3.12 1.656h2Zm0 .441.802 1.832A2 2 0 0 0 4 42.118H2Zm0 0-.802-1.832a2 2 0 0 0-.331 3.48L2 42.118Zm0 0h2a2 2 0 0 0-.867-1.648L2 42.118Zm0 13.667H0A2 2 0 0 0 .88 57.44L2 55.785ZM43.682 84l-1.121 1.656A2 2 0 0 0 45.68 84h-2Zm0-13.667-.816-1.826a2 2 0 0 0-1.184 1.826h2Zm9.808-4.382 1.121-1.656a2 2 0 0 0-1.937-.17l.816 1.826Zm.612.415-1.121 1.656a2 2 0 0 0 3.121-1.656h-2Zm0-.688-.816-1.826a2 2 0 0 0-1.184 1.826h2Zm.434-.194.816 1.826a2 2 0 0 0 .305-3.483l-1.12 1.657Zm-.434-.294h-2a2 2 0 0 0 .879 1.656l1.121-1.656Zm0-12.491-.816-1.826a2 2 0 0 0-1.184 1.826h2Zm9.809-4.382 1.12-1.657a2 2 0 0 0-1.936-.17l.816 1.827Zm.611.414-1.12 1.656a2 2 0 0 0 3.12-1.656h-2Zm0-.688-.815-1.826a2 2 0 0 0-1.185 1.826h2Zm.435-.194.816 1.826a2 2 0 0 0 .305-3.482l-1.121 1.656Zm-.435-.294h-2a2 2 0 0 0 .88 1.657l1.12-1.657Zm0-12.49-.815-1.827a2 2 0 0 0-1.185 1.827h2ZM32.574 3.656l41.682 28.215 2.242-3.312L34.816.344l-2.242 3.312ZM24.05 8.5l10.462-4.674L32.88.174 22.418 4.848 24.05 8.5Zm.305-3.482-.392-.266-2.242 3.313.392.265 2.242-3.312Zm-3.513 1.39v.441h4v-.44h-4Zm0 .441v12.98h4V6.848h-4Zm1.184 11.153-10.028 4.48 1.631 3.653 10.029-4.48-1.632-3.653Zm-8.091 4.65-.393-.265-2.242 3.312.392.266 2.243-3.313Zm-3.514 1.391v.44h4v-.44h-4Zm0 .44v12.98h4v-12.98h-4Zm1.185 11.154-10.028 4.48 1.631 3.652 10.028-4.48-1.631-3.652Zm-8.091 4.65-.393-.266L.88 43.334l.392.265 2.242-3.312ZM0 41.677v.441h4v-.44H0Zm1.198-1.391 1.604 3.664-1.604-3.664Zm-.331 3.48 2.266-3.296-2.266 3.296ZM0 42.118v13.667h4V42.118H0ZM.88 57.441l41.682 28.215 2.242-3.312L3.12 54.129.88 57.44ZM45.682 84V70.333h-4V84h4Zm-1.184-11.84 9.808-4.383-1.632-3.652-9.808 4.382 1.632 3.652Zm7.87-4.552.613.414 2.242-3.313-.612-.414-2.242 3.313Zm3.734-1.242v-.688h-4v.688h4Zm-1.184 1.138.434-.194-1.632-3.652-.434.194 1.632 3.652Zm.74-3.677-.435-.293-2.242 3.312.434.294 2.242-3.313Zm.444 1.363V52.699h-4v12.49h4Zm-1.184-10.665 9.808-4.382-1.631-3.652-9.809 4.382 1.632 3.652Zm7.871-4.552.612.414 2.242-3.312-.611-.415-2.243 3.313Zm3.733-1.242v-.688h-4v.688h4Zm-1.184 1.138.434-.194-1.631-3.652-.434.194 1.631 3.652Zm.74-3.676-.434-.294-2.243 3.313.434.294 2.243-3.313Zm.444 1.362v-12.49h-4v12.49h4Zm8.04-19.166-10.855 4.85 1.631 3.652 10.855-4.85-1.632-3.652Z"
      fill="#667786"
      mask="url(#review-icon-6-a)"
    />
    <path
      d="M2.5 55.52v-12.9l40.682 27.538v12.9L2.5 55.52Z"
      fill="#B8B1B5"
      stroke="#667786"
      strokeLinejoin="round"
    />
    <path
      d="m3.025 42.208 9.78-4.37 40.707 27.556-9.78 4.37L3.025 42.207Z"
      fill="#DBD8DA"
      stroke="#667786"
      strokeLinejoin="round"
    />
    <path
      d="M12.92 37.885v-12.9l40.682 27.538v12.9L12.92 37.885Z"
      fill="#B8B1B5"
      stroke="#667786"
      strokeLinejoin="round"
    />
    <path
      d="m13.445 24.574 9.78-4.37L63.932 47.76l-9.78 4.369-40.707-27.555Z"
      fill="#DBD8DA"
      stroke="#667786"
      strokeLinejoin="round"
    />
    <path
      d="M23.34 20.25V7.35L64.023 34.89v12.9L23.341 20.25Z"
      fill="#B8B1B5"
      stroke="#667786"
      strokeLinejoin="round"
    />
    <path
      d="m23.866 6.94 9.78-4.37 40.707 27.555-9.78 4.37L23.866 6.939Z"
      fill="#DBD8DA"
      stroke="#667786"
      strokeLinejoin="round"
    />
  </svg>
);
